<template>
  <article class="trainers">

    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap>
          <v-flex lg9>
            <p class="table_card__head--title">Crear evento</p>
            <v-breadcrumbs class="breadcums">
              <v-icon slot="divider">chevron_right</v-icon>
              <v-breadcrumbs-item
                @click="$router.push({name: 'events'})"
                class="breadcums__option"
              >
                Eventos creados
              </v-breadcrumbs-item>
              <v-breadcrumbs-item
                disabled
                class="breadcums__disable"
              >
                Crear evento
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </v-flex>
          <v-flex lg3 class="filter_options">
            <v-flex class="right mr-1">
              <button
                class="faccess_button px-5"
                :disabled="formIsInError"
                @click="formIsInError?'':createEvent()"
              >
                Crear
              </button>
            </v-flex>
          </v-flex>
        </v-layout>
      </div>
      <div class="table_card__info">
        <v-layout row wrap>
          <v-flex xs6>
            <v-flex xs12 v-if="event.attributes.video_published">
              <span class="table_card__info--label">Url video</span>
              <input
                class="faccess_input"
                type="text"
                :style="event.attributes.url.length<=0&&activeErrorName?'border:2px solid red !important;background-color:#ef4b4b19':''"
                name="Name"
                @blur="activeErrorName=true"
                placeholder="Url del video"
                v-model="event.attributes.url">
            </v-flex>
            <!-- Fotos de la oferta -->
            <span
              v-if="event.attributes.video_published === false"
              class="table_card__info--label">Imagen o Video</span>
            <div
              v-if="event.attributes.video_published === false"
              class="trainers__form--photo_container">
              <label
                for="trainerPhoto"
                class="faccess_button buttom_shadow px-5">Examinar</label>
              <input
                id="trainerPhoto"
                type="file"
                accept="image/x-png,image/gif,image/jpeg"
                @change="onFileChange"
                name="logo">
              <p>{{photo_name=='manager'?'No se han seleccionado archivos':photo_name}}</p>
            </div>
            <v-flex xs12>
              <v-switch
                class="data_card_special__switch"
                :label="`Habilitar video`"
                @change="event.attributes.video_published === true ? event.attributes.url = '' : ''"
                v-model="event.attributes.video_published"
                color="#1476FB"
              >
              </v-switch>
            </v-flex>
            <v-flex xs12>
              <span class="table_card__info--label">Título</span>
              <input
                class="faccess_input"
                type="text"
                :style="event.attributes.name.length<=0&&activeErrorName?'border:2px solid red !important;background-color:#ef4b4b19':''"
                name="Name"
                @blur="activeErrorName=true"
                placeholder="Título del evento"
                v-model="event.attributes.name">
            </v-flex>
            <v-flex xs12>
              <span
              style="margin-bottom: 10px; display: block;"
              class="table_card__info--label">Contenido</span>
              <ckeditor class="ckeditor"
              :editor="editor" v-model="event.attributes.description" :config="editorConfig"></ckeditor>
            <!--  <v-textarea
                name="Contenido"
                class="data_card_special__textarea"
                v-model="event.attributes.description"
                :style="event.attributes.description.length<=0&&activeErrorName?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
              ></v-textarea> -->
            </v-flex>
            <v-flex xs12>
                <span
                style="margin-bottom:0px; display: block; margin-top: 20px;"
                class="table_card__info--label">Fecha del evento</span>
                <app-single-date-picker
                  @filterQuery="changeDate($event)"
                  :solid="false"
                  :clases="false"
                  width="100%"
                >
                </app-single-date-picker>
            </v-flex>
            <v-flex xs12>
              <span
                class="table_card__info--label"
                style="margin-bottom:0px; display: block; margin-top: 20px;"
              > Sedes</span>
              <v-select
                label="Selecciona"
                v-bind:items="locationslist"
                :item-text="'attributes.name'"
                :item-value="'id'"
                v-model="event.attributes.location_id"
                single-line
                solo
                color="#1476FB"
              ></v-select>
            </v-flex>
            <v-flex xs12 >
              <span class="table_card__info--label">Categoría</span>
              <v-select
                label="Selecciona"
                :items="specialCategoriesList"
                :item-text="'attributes.name'"
                :item-value="'id'"
                v-model="event.attributes.special_category_id"
                single-line
                solo
                color="#1476FB"
              ></v-select>
            </v-flex>
            <v-flex xs12>
              <v-switch
                class="data_card_special__switch"
                :label="`Visible para los usuarios`"
                v-model="event.attributes.visible_to_user"
                color="#1476FB"
              >
              </v-switch>
            </v-flex>
            <v-flex xs12 style="display:flex;max-width:150%; width:150% !important; margin-top:50px;" v-if="fieldError.length>0" >
              <p style="color:red;font-size:15px">
                Complete para continuar: {{fieldError}}
              </p>
            </v-flex>
          </v-flex>

          <!-- Inicia tarjeta de la derecha -->
          <v-flex xs6 >
            <v-flex xs12 class="preview_item">
              <section class="data_card_special data_card_special__instance">
                <div
                  class="data_card_special__image"
                  :class = "{'without_url' : !url_change}"
                  :style="{backgroundImage: 'url('+ url +')'}"></div>
                <div class="data_card_special__info">
                  <div class="data_card_special__info--container">
                    <p class="data_card_special__info--title_form">
                      {{event.attributes.name}}
                    </p>
                  </div>
                  <div class="data_card_special__info--container">
                    <span class="data_card_special__info--label_form_right">Descripción</span>
                    <p class="data_card_special__info--text_form full_text" v-html="event.attributes.description">
                      <!-- {{}} -->
                    </p>
                  </div>
                  <div class="data_card_special__info--container">
                    <span class="data_card_special__info--label_form_right">Es visible para los usuarios</span>
                    <span class="data_card_special__info--label_form_show">{{ event.attributes.visible_to_user ? 'Si' : 'No' }}</span>
                  </div>
                </div>
              </section>
            </v-flex>
          </v-flex>
          <!-- Termina tarjeta de la derecha -->
        </v-layout>
      </div>
      <div class="table_card__footer">
        <button
          class="faccess_button px-5"
          :disabled="formIsInError"
          @click="formIsInError ? '' : createEvent()"
        >
          Crear
        </button>
      </div>
    </div>

  </article>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data(){
    return{
      /* news_types: ['Normal', 'Video','Titular'], */
      manager_url_change: false,
      schedule_url_change: false,
      schedule_url: '',
      manager_url: '',
      photo_name: 'No se han seleccionado archivos',
      activeErrorName:false,
      locationslist: '',
      specialCategoriesList: '',
      fieldError:'',
      url_change: false,
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      event:{
        attributes:{
          special_category_id: '',
          location_id: '',
          name: '',
          event_date: '',
          description: '',
          url: '',
          url_type: '',
          visible_to_user: false,
          video_published: false
        },
      },
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'Link','Unlink',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'Outdent','Indent',
            /*        '|',
            'Blockquote',
            'insertTable', */
            '|',
            'undo',
            'redo'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        },
        language: 'es'
      },
    }
  },
  mounted(){
    this.locationslist = this.getLocations();
    this.findSpecialCategories();

  },
  watch:{
    url(){
      this.url_change = true;
    },
    schedule_url(){
      // cl schedule_url
      if(this.schedule_url != ''){
        this.schedule_url_change = true;
      }
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    }
  },
  computed:{
    formIsInError(){
      var ans=false
      let fields=[]
      if(!this.url_change && this.event.attributes.name.length==0){
        fields.push("'Imagen principal o Video'")
      }
      if(this.event.attributes.name.length==0){
        fields.push("'Nombre'");
      }
      if(this.event.attributes.description.length==0){
        fields.push("'Contenido'")
      }
      if(this.event.attributes.event_date.length==0){
        fields.push("'Fecha de evento'")
      }
      if(this.event.attributes.location_id.length==0){
        fields.push("'Sede'")
      }
      if(this.event.attributes.special_category_id.length==0){
        fields.push("'Categoria'")
      }
      if(this.scheduleIsInError){
        fields.push("''")
      }
      if(fields.length>0){
        if(fields.length==2){
          this.fieldError=fields.join(" y ")
        }else{
          this.fieldError=fields.join(" , ")
        }

        ans=true
      }else{
        this.fieldError=""
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },
  },
  methods:{
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      if (name_field=='schedule') {
        this.schedule_url = URL.createObjectURL(files[0]);
      }else if(name_field=='manager'){
        this.manager_url = URL.createObjectURL(files[0]);
      } else {
        this.url = URL.createObjectURL(files[0]);
      }
      this.createImage(files[0], ""+e.target.name)
    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {

        if (name_field=='schedule') {
          vm.event.attributes.schedule_image = reader.result
        }else if(name_field=='manager'){
          vm.event.attributes.manager_image = reader.result
        } else {
          //vm.location.attributes.image = reader.result
          vm.event.attributes.url = reader.result
        }
        vm.photo_name=name_field
        // vm.location.attributes.image = reader.result
      }
    },
    findLocations(){
      try {
        this.$http.get('app/locations/index',{
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.locationslist = response.body.data
          console.log('this.locationslist ', this.locationslist)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findSpecialCategories(){
      try {
        this.$http.get('app/special_categories/index',{
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.specialCategoriesList = response.body.data
          console.log('this.specialCategoriesList ', this.specialCategoriesList)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    createEvent(){
      this.event.attributes.video_published === false ? this.event.attributes.url_type = 'img' : this.event.attributes.url_type = 'video'

      try {
        this.$http.post('app/events/create', { data: this.encrypt(this.event).toString() },
          {headers:
            {
             "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
            }
          })
        .then(function(response){
          console.log(response);
          this.$router.push({name: 'events'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        console.log(e);
        alert(e.message)
      }
    },
    changeRewardDate(val, context){
      this.reward_attributes[context] = val
    },
    changeDate(val){
      // cl val
      this.event.attributes.event_date = val
    },

  } //closed methods
}
</script>



// WEBPACK FOOTER //
// src/components/views/events/New_event.vue